import { Deserializable } from '../protocols/deserializable';

export class NewMemberVerificationRequest implements Deserializable {
  public firstName!: string;
  public lastName!: string;
  public birthDate!: string;
  public socialInsuranceNumber!: string;

  public onDeserialize(): void {}
}
